export enum OrderTransactionProductType {
  DELETED = 'deleted',
  PURCHASE = 'purchase',
  RETURN = 'return',
  REDEMPTION = 'redemption',
  REDEMPTION_REFUND = 'redemption refund',
  UNKNOWN_DISCOUNT = 'unknown discount',
  VOIDED = 'voided',
}
